import type { Role, StatusItem } from '../../../types/domain'

export const BUYER_READONLY_FIELDS = [
  'numero_requisicao',
  'data_requisicao',
  'obra',
  'setor',
  'requisitante_id',
  'codigo',
  'descricao',
  'grade1',
  'grade2',
  'grade3',
  'unidade',
  'quantidade_solicitada',
  'necessidade',
  'prioridade',
] as const

export function canAccessBuyerMode(role: Role): boolean {
  return role === 'COMPRADOR' || role === 'ADMIN'
}

export function parseBuyerQuantity(value: string): number | null {
  const normalized = value.trim().replace(',', '.')
  if (!normalized) return null
  const parsed = Number(normalized)
  return Number.isFinite(parsed) ? parsed : null
}

export function suggestItemStatus(quantity: number | null, requested: number): StatusItem | null {
  if (quantity === null || quantity <= 0) return null
  return quantity >= requested ? 'Atendido' : 'Atendido Parcial'
}
